import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../models';
import { AdminService, ApiService, AuthService, SessionService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
  selector: 'sn-usc-sms-hosting',
  templateUrl: './usc-sms-hosting.component.html',
  styleUrls: ['../usc-store.component.css', './usc-sms-hosting.component.css']
})
export class UscSmsHostingComponent implements OnInit {
  @Input() selected_store:any;

  public name:string;
  public email:string;
  public is_authorized:boolean;
  public phone_number:string;
  public store_name:string;
  public status:string;
  public status_class:string;
  public date:string;
  public is_awaiting_authorization:boolean;
  public is_authorization_submitted:boolean;
  public is_sms_hosting_enabled:boolean;
  public stores:any[] = [];
  public store:User;
  public activeUser:User;
  // public updated_stores: any[] = [];
  public sn_sso_deployment:string;
  public is_sn_sso_deployment:boolean;
  public associates_added_to_amp:string;
  public is_associates_added_to_amp:boolean;

  constructor(
    public uscStoreService: UscStoreService,
    public authService: AuthService,
    public apiService: ApiService,
    public adminService: AdminService,
    public ngbModal: NgbModal,
    public sessionService: SessionService
  ) { }

  ngOnInit() {
    this.activeUser = this.authService.getActive();
    this.store = this.activeUser;
    if (this.activeUser.title == "Master") {
      let dlg = this.showCustomPromptDlg({ }, { msg: "Loading Stores" });
      setTimeout(() => { this.getTeamMembers(dlg); }, 1 * 100);
    } else {
      this.updateFieldByStore(this.activeUser, this.store);
    }
  }

  getTeamMembers(dlgLoading:NgbModalRef) {
    if (this.adminService.getAllUsers() == null) {
      setTimeout(() => { this.getTeamMembers(dlgLoading); }, 1 * 1000);
    } else {
      if (dlgLoading) dlgLoading.dismiss();
      var members = this.adminService.getTeamMembersByUser(this.activeUser);
      members.forEach(s => {
        if (s.title == "Store") this.stores.push(s);
      });
      this.store = this.stores[0];
      if (this.selected_store) this.store = this.selected_store;
      this.updateFieldByStore(this.activeUser, this.store);
    }
  }

  updateFieldByStore(activeUser:User, store:User) {
    this.store_name = `${store.first_name} (${store.last_name})`; 
    this.phone_number = this.uscStoreService.getItemCustomFieldValue(store, "Phone Number");
    this.status = this.uscStoreService.getItemCustomFieldValue(store, "SMS Hosting Status");
    if (this.status == undefined || this.status.length == 0) this.status = 'Awaiting Authorization';
    this.status_class = this.status.toLocaleLowerCase().replace(/ /g, '_');
    this.name = this.uscStoreService.getItemCustomFieldValue(store, "Authorized By Name");
    this.email = this.uscStoreService.getItemCustomFieldValue(store, "Authorized By Email");
    this.date = this.uscStoreService.getItemCustomFieldValue(store, "Authorized Date");
    this.is_authorized = this.uscStoreService.getItemCustomFieldValue(store, "Authorization") == "Yes";
    this.associates_added_to_amp = this.uscStoreService.getItemCustomFieldValue(store, "Associates added to AMP");
    this.is_associates_added_to_amp = this.associates_added_to_amp == "Yes";
    if (activeUser.title == "Master") {
      this.sn_sso_deployment = this.uscStoreService.getItemCustomFieldValue(activeUser, "SSO Deployment Authorized");
    } else {
      this.sn_sso_deployment = this.uscStoreService.getItemCustomFieldValue(store, "SSO Deployment Authorized");
    }
    this.is_sn_sso_deployment = this.sn_sso_deployment == "Yes";

    this.is_awaiting_authorization = this.is_authorization_submitted = this.is_sms_hosting_enabled = false;
    switch (this.status)
    {
      case "Awaiting Authorization": this.is_awaiting_authorization = true; break;
      case "Authorization Submitted": this.is_authorization_submitted = true; break;
      case "SMS Hosting Enabled": this.is_sms_hosting_enabled = true; break;
    }
  }

  storeChange(event) {
    this.store = this.stores.find(s => s.ID == event.currentTarget.value); 
    this.updateFieldByStore(this.activeUser, this.store);
  }

  validate() {
    return (this.phone_number && this.name && this.email && this.is_authorized);
  }

  sms_authorize() {
    var data = {
      "User ID": this.store.ID,
      "Username": this.store.username,
      "Phone Number": this.phone_number,
      "Authorized By Name": this.name,
      "Authorized By Email": this.email,
      "Authorization": this.is_authorized ? "Yes" : "No",
      "Authorized Date":  (new Date()).toISOString()
    };
    console.log('sms_authorize data', data);
    this.adminService.processUserAction("sms_hosting_authorization", data, "raw").subscribe(
      store => {
        console.log('sms_authorize succeed', store);
        // update current store with update custom_fields
        this.store.json_custom_fields = store.json_custom_fields;
        // this.updated_stores.push(store);
        this.updateFieldByStore(this.activeUser, this.store);
    }, 
      err => { 
        console.log('sms_authorize failed', err);
        this.sessionService.log("unable to authorize SMS Hosting");
      }
    )  
  }

  showCustomPromptDlg(item, msg_config):NgbModalRef {
    const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
    modalRef.componentInstance.parentView = this.uscStoreService.view_sms_hosting;
    modalRef.componentInstance.data = item;
    modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
    modalRef.componentInstance.msg_config = msg_config;
    return modalRef;
  }

  sso_authorize() {
    console.log('sso_authorize');
    var data = {
      "User ID": this.store.ID,
      "Username": this.store.username,
      "SSO Deployment Authorized": this.is_sn_sso_deployment ? "Yes": "No",
    };
    this.adminService.processUserAction("sso_deployment_authorization", data, "raw").subscribe(
      user => {
        console.log('sso_authorize succeed', user);
        if (this.activeUser.ID == user.ID) {
          if (this.sn_sso_deployment != "Yes") this.uscStoreService.setItemCustomFieldValue(this.activeUser, "SSO Deployment Authorized", "Yes");
        }
        this.updateFieldByStore(this.activeUser, this.store);
      }, 
      err => { 
        console.log('sso_authorize failed', err);
        this.sessionService.log("unable to authorize SSO Deployment");
      }
    )  
  }

  amp_confirm() {
    var data = {
      "User ID": this.store.ID,
      "Username": this.store.username,
      "SSO Deployment Authorized": this.is_sn_sso_deployment ? "Yes": "No",
      "Associates added to AMP": this.is_associates_added_to_amp ? "Yes": "No",
    };
    this.adminService.processUserAction("amp_confirmation", data, "raw").subscribe(
      store => {
        this.store.json_custom_fields = store.json_custom_fields;
        this.updateFieldByStore(this.activeUser, this.store);
      }, 
      err => { 
        this.sessionService.log("unable to confirm AMP enrollment");
      }
    )  
  }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-sms-hosting/usc-sms-hosting.component.ts